<div class="display-flex flex-align-center overflow-hidden m-w-0 full-height gap-0-5em">
  <span class="text-ellipsis">{{ periodStr | translate }} <span class="range">({{ rangeStr }})</span></span>
  <mat-icon class="color-green compare-icon display-inline" *ngIf="compare"
            [customToolTip]="'datepicker.trigger_compare_with' | translate:{type: periodComparisonStr | translate, range: rangeComparisonStr}">compare_arrows
  </mat-icon>
</div>
